<script>
import VTooltipWrapper from "../../common/v-tooltip-wrapper.vue";
import utility, {formatDate} from "../../../utility";
import {localizeDate} from "../../../../utils/date";
import {formatTime, getTimeFormat} from "../../../../utils/time";

export default {
    name: "validity-display",
    components: {VTooltipWrapper},
    props: {
        id: Number | String,
        element: {},
        colorOnlyText: Boolean,
        disableTooltip: Boolean,
        duration: String,
        chip: Boolean,
        noTime: Boolean,
        timepickerMode: Number | String
    },
    computed: {
        displayedText() {
            return `${this.duration}, ${this.validity.text}`;
        },
        tooltipReference() {
            return `validity-display-tooltip-${this.id}`;
        },
        tooltipText() {
            const [dateValidity, timeValidity] = this.validity.text.split(',');
            return {
                duration: `${Lang.langGet('Duration')}: ${this.duration}`,
                dateValidity,
                timeValidity,
            }
        },
        validity() {
            const validFrom = this.getDate('valid_from');
            const validTo = this.getDate('valid_to');

            if (this.element.literal_times) {
                return this.checkLiteralTimes(validFrom, validTo, this.element.valid_time_from, this.element.valid_time_to, this.timepickerMode);
            }

            if (this.noTime) return utility.checkValidity(validFrom, validTo);

            const time = {
                From: this.element.valid_time_from ?? {HH: null, mm: null},
                To: this.element.valid_time_to ?? {HH: null, mm: null}
            };

            return utility.checkValidity(validFrom, validTo, time);
        },
        iconClass() {
            if(this.element.literal_times) return 'far fa-calendars mr-2'
            return 'far fa-calendar mr-2';
        }
    },
    methods: {
        getDate(prop) {
            const value = this.element[prop];
            const placeholder = this.element[`${prop}_placeholder`];

            if (this.element.validityDetached) {
                return value;
            }

            return value ? value : placeholder;
        },
        constructTime(startTime, endTime, timepickerMode) {
            let timeFrom = startTime.split(':');
            let timeTo = endTime.split(':');

            if (timeFrom.length !== 2) {
                timeFrom = {HH: '00', mm: '00'};
            } else {
                timeFrom = {HH: timeFrom[0], mm: timeFrom[1]};
            }

            if (timeTo.length !== 2) {
                timeTo = {HH: '00', mm: '00'};
            } else {
                timeTo = {HH: timeTo[0], mm: timeTo[1]};
            }

            let formatedFrom = formatTime({
                h: +timeFrom.HH,
                m: +timeFrom.mm
            }, getTimeFormat(timepickerMode));

            let formatedTo = formatTime({
                h: +timeTo.HH,
                m: +timeTo.mm
            }, getTimeFormat(timepickerMode));

            if (formatedFrom === '00:00') formatedFrom = null;
            if (formatedTo === '00:00') formatedTo = null;

            return [formatedFrom, formatedTo];
        },
        checkLiteralTimes(from, to, startTime, endTime, timepickerMode) {
            const now = new Date();

            from = (from === '' || from === 'null' || from === null) ? undefined : from;
            to = (to === '' || to === 'null' || to === null) ? undefined : to;

            const startDate = from ? localizeDate(from) : '';
            const endDate = to ? localizeDate(to) : '';

            if (!from && !to && !startDate && !endDate) {
                return {status: 'normal', text: Lang.langGet('always valid')};
            }

            const [formatedStartTime, formatedEndTime] = this.constructTime(startTime, endTime, timepickerMode);

            const left = [startDate, formatedStartTime].filter(Boolean).join(' ');
            const right = [endDate, formatedEndTime].filter(Boolean).join(' ');

            const text =
                left && right ? `${left} - ${right}` :
                    left ? left :
                        right ? right : '';

            let status = 'normal';

            if (from === undefined && to === undefined) {
                status = 'normal';
            } else if (from === undefined && to !== undefined) {
                let toParsed = formatDate(to, 'MM/dd/YYYY');
                toParsed.setDate(toParsed.getDate() + 1);

                status = 'past';
                if (toParsed > now) status = 'normal';
            } else if (from !== undefined && to === undefined) {
                let fromParsed = formatDate(from, 'MM/dd/YYYY');
                status = (fromParsed > now) ? 'future' : 'normal';
            } else {
                let fromParsed = formatDate(from, 'MM/dd/YYYY');
                let toParsed = formatDate(to, 'MM/dd/YYYY');
                toParsed.setDate(toParsed.getDate() + 1);

                if (fromParsed > now) status = 'future';
                else if (toParsed < now) status = 'past';
                else status = 'normal';
            }

            return {status, text};
        }
    }
}
</script>

<template>
    <v-chip v-if="chip" :class="`${validity.status} elevation-1`" label small>
        <i :class="iconClass"/>
        {{ validity.text }}
    </v-chip>
    <div v-else :id="tooltipReference" class="validity-display file-name" :class="colorOnlyText ? null : validity.status">
        <i class="fa-regular fa-clock m-r-xs"/>
        <span :class="colorOnlyText ? validity.status : null">{{ displayedText }}</span>
        <v-tooltip-wrapper v-if="!disableTooltip" :activator="`#${tooltipReference}`">
            <div class="d-flex flex-column">
                <div class="flex-row">{{ tooltipText.duration }}</div>
                <div class="flex-row">{{ tooltipText.dateValidity }}</div>
                <div class="flex-row">{{ tooltipText.timeValidity }}</div>
            </div>
        </v-tooltip-wrapper>
    </div>
</template>

<style scoped>
.validity-display {
    cursor: default;
    border-radius: 8px;
}
</style>
